import { isResponsiveObject, ResponsiveProp, UIBreakpoint } from "@shared/constaints/ui";
import { sortedBreakpoints } from "@shared/libs/breakpoint.utils";
import { useScreenSize } from "@shared/hooks/useScreenSize";

export const useResponsiveProp = <T>(
  prop: ResponsiveProp<T> | undefined,
  currentBreakpoint?: UIBreakpoint,
): T | undefined => {
  const { currentBreakpoint: screenBreakpoint } = useScreenSize();

  if (!prop) return undefined;

  if (!isResponsiveObject(prop)) return prop;

  const breakpointKeys: UIBreakpoint[] = ['base', ...sortedBreakpoints];

  const currentIndex = breakpointKeys.indexOf(currentBreakpoint ?? screenBreakpoint);

  for (let i = currentIndex; i >= 0; i--) {
    const key = breakpointKeys[i];
    if (key in prop) {
      return prop[key as keyof typeof prop] as T;
    }
  }

  return undefined;
};